// Normalize a detached model without overwriting its imported root transform.
export function center_model(THREE, model){
    const bounds = new THREE.Box3().setFromObject(model, true);
    const sphere = bounds.getBoundingSphere(new THREE.Sphere());
    const offset = new THREE.Group();
    offset.add(model);
    if(!bounds.isEmpty()) offset.position.copy(sphere.center).negate();
    const pivot = new THREE.Group();
    pivot.add(offset);
    pivot.scale.setScalar(sphere.radius > 0 ? 1 / sphere.radius : 1);
    return pivot;
}

// A unit bounding sphere stays inside the frame at every rotation angle.
// Use the narrower field of view so portrait viewports also fit the model.
export function fit_model_camera(camera){
    const vertical = camera.getEffectiveFOV() * Math.PI / 360;
    const horizontal = Math.atan(Math.tan(vertical) * camera.aspect);
    const distance = 1.12 / Math.sin(Math.min(vertical, horizontal));
    camera.position.set(1.8, 1.4, 2.2).normalize().multiplyScalar(distance);
    camera.near = Math.max(0.01, distance - 1.5);
    camera.far = distance + 1.5;
    camera.lookAt(0, 0, 0);
    camera.updateProjectionMatrix();
}
